// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1PaZk","content":"styles_content__1ks11"};